<template>
  <div
    :class="{ small }"
    class="gradient-preview"
  >
    <div class="gradient-preview-content">
      <p>{{ $t('article_not_available') }}</p>
      <button
        class="btn btn-primary"
        @click="emit('showCard')"
      >
        {{ $t('view_contents') }}
      </button>
      <nuxt-link
        :aria-label="title"
        :to="link"
        class="btn btn-violet"
      >
        {{ $t('read_original_article') }}
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  link: string
  title: string
  small?: boolean
}>();

const emit = defineEmits(['showCard']);
</script>

<style lang="scss" scoped>
.gradient-preview {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  z-index: 5;

  &.small {
    font-size: 14px;

    .gradient-preview-content .btn {
      height: unset;
      min-height: unset;
      padding: 8px 12px;
    }
  }

  &-content {
    position: relative;
    z-index: 10;
    text-align: center;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    gap: 8px;

    p {
      margin-bottom: 12px;
    }
  }

}
</style>
